export const TICKET_TYPES = [
  { value: "incident", label: "Incident" },
  { value: "service_request", label: "Service Request" },
  { value: "problem", label: "Problem" },
  { value: "change", label: "Change" },
  { value: "maintenance", label: "Maintenance" },
] as const;

export const TICKET_PRIORITIES = [
  { value: "critical", label: "Critical" },
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
] as const;

export const TICKET_STATUSES = [
  { value: "new", label: "New" },
  { value: "open", label: "Open" },
  { value: "assigned", label: "Assigned" },
  { value: "in_progress", label: "In Progress" },
  { value: "waiting_on_client", label: "Waiting on Client" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
] as const;

/** Every status a ticket can show, including VOID. VOID is only ever set through
 *  execute_void_ticket (src/lib/ticket-void.ts), so pickers that write the status
 *  directly (bulk edit, new ticket) keep using TICKET_STATUSES. */
export const TICKET_STATUSES_ALL = [
  ...TICKET_STATUSES,
  { value: "void", label: "VOID" },
] as const;

export const JOB_TYPES = [
  { value: "remote", label: "Remote" },
  { value: "onsite", label: "On-site" },
  { value: "in_shop", label: "In Shop" },
  { value: "drop_off", label: "Drop-off" },
  { value: "pick_up", label: "Pick-up" },
  { value: "project", label: "Project" },
  { value: "preventive_maintenance", label: "Preventive Maintenance" },
] as const;

export const TRIP_CHARGE_ZONES = [
  { value: "none", label: "None" },
  { value: "zone_1", label: "Zone 1" },
  { value: "zone_2", label: "Zone 2" },
  { value: "zone_3", label: "Zone 3" },
  { value: "zone_4", label: "Zone 4" },
] as const;

export const PRIORITY_BADGE: Record<string, string> = {
  critical: "bg-red-500/15 text-red-600 border-red-500/40",
  high: "bg-orange-500/15 text-orange-600 border-orange-500/40",
  medium: "bg-yellow-500/15 text-yellow-700 border-yellow-500/40",
  low: "bg-gray-500/15 text-gray-600 border-gray-500/40",
};

export const STATUS_BADGE: Record<string, string> = {
  new: "bg-purple-500/15 text-purple-600 border-purple-500/40",
  open: "bg-sky-500/15 text-sky-600 border-sky-500/40",
  assigned: "bg-blue-500/15 text-blue-600 border-blue-500/40",
  in_progress: "bg-blue-500/15 text-blue-600 border-blue-500/40",
  waiting_on_client: "bg-yellow-500/15 text-yellow-700 border-yellow-500/40",
  resolved: "bg-emerald-500/15 text-emerald-600 border-emerald-500/40",
  closed: "bg-gray-500/15 text-gray-600 border-gray-500/40",
  void: "bg-foreground/80 text-background border-destructive border-2 uppercase font-bold tracking-wide",
  voided: "bg-foreground/80 text-background border-destructive border-2 uppercase font-bold tracking-wide",
};

export const labelOf = (
  arr: readonly { value: string; label: string }[],
  v: string | null | undefined,
) => arr.find((x) => x.value === v)?.label ?? v ?? "—";
